import React, { useEffect, useState, useContext } from 'react';
import { Form, Button} from 'react-bootstrap';
import { Calendar } from 'react-date-range';
import moment from 'moment';

import IsLoadingBar from '../isLoading';
import Auth from '../../Auth/Auth';
import { MsalContext } from "../../Auth/msal-context";

import fetchConfused from '../../images/10607-dog-avatar-confused.png';
import fetchShock from '../../images/10607-dog-avatar-shock.png';
import backupNew from '../../images/new backup.png';
import backupPointInTime from '../../images/point-in-time.png';
import check from '../../images/check.png';

import './RequestBackup.scss';

const auth = new Auth();

Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

var dateNow = new Date();


const RequestBackup = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isRegistering, setIsRegistering] = useState(false);
    const [userNotRegistered, setUserNotRegistered ]  = useState(false);
    const [requestSubmitted, setRequestSubmitted ]  = useState(false);
    const [userHasFastLaneAccess, setHasFastLaneAccess] = useState(false);
    const [backupInQueue, setBackupInQueue] = useState(false);  
    const [backupSubmitted, setBackupSubmitted] = useState(false);  
    const [backupAvailable, setBackupAvailable] = useState(false);    
    const [backupIn24Hour, setBackupIn24Hour] = useState(false); 
    const [fastlaneEnabled, setFastlaneEnabled] = useState(false);   

    const [teams, ] = useState(["Support - SMB /\ Major | Global/Managed | PowerPay","Support - Enterprise","Implementation","Reporting | DF Link", "Technical Account Management", "Professional Services","Other"]);
    const [userTeam, setUserTeam] = useState(null);
    const [userLeaserID, setLeaserID] = useState(null);
    const [activeNamespace, setActiveNamespace] = useState(null);
    const [notificationMessage, setNotificationMessage] = useState(null);
    const [requestError, setRequestError] = useState(null);    
    
    const [backupFileName, setBackupFileName] = useState(null);
    const [backupDate, setBackupDate] = useState(null);
    const [backupType, setBackupType] = useState(null);  
    const [date, setDate] = useState(null);
    const [hour, setHour] = useState("00");
    const [minute, setMinute] = useState("00"); 
    const [requestMsg ,setRequestMsg] = useState(""); 
    
    const { setUserAltocumulus, setUserAltocumulusAccess } = useContext(MsalContext);

    useEffect(() => {      
      checkUserRegistered();

      window.onkeydown = function(e) {
            if (e.keyCode === 9) {
            e.preventDefault();
            let nextInput = document.getElementById("minute-input");
            if (nextInput) {
                nextInput.focus();
            }
            }
        };

        return () => {
            window.onkeydown = null;
        };
    },[]);

    useEffect(() => {  
        if(props.UserNotRegistered !== null){
            setUserNotRegistered(true);
            setIsLoading(false);
        }
    },[props.UserNotRegistered]);

    useEffect(() => {    
        if(props.namespace){
            setActiveNamespace(props.namespace);
        }          
    },[props.namespace]);

    const checkUserRegistered = async () => {        
        let accessToken = await auth.getToken();

        fetch(`/api/checkuserregistered`, {
            method : "GET",
            headers: {
                'Authorization': "Bearer " + accessToken
            }
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => { 
            if(data && data.LeaserID === 0){
                setUserNotRegistered(true);
                setIsLoading(false);
                return;
            }

            setUserNotRegistered(false);
            setLeaserID(data.LeaserID);
            setHasFastLaneAccess(data.HasFastLaneAccess);
            checkBackupExists();            
        }).catch((error) => {
            window.apiError(error);
        });
    };

    const checkBackupExists = async () => {
        let accessToken = await auth.getToken();
        fetch(`/api/checkforbackup`, {
            method : "POST",
            headers: {
                'Content-Type' : 'application/json',
                'Authorization': "Bearer " + accessToken
            },
            body : JSON.stringify( { namespace : props.namespace })
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => { 
            if(data.BackupFile){
                setBackupFileName(data.BackupFile);
                getBackupDate(data.BackupFile);
                setBackupAvailable(true);
            } else {
                setBackupInQueue(data.InQueue);
            }            
            setIsLoading(false);
        }).catch((error) => {
            window.apiError(error);
        });
        
    };

    const upHour = () => {
        if(hour === 23){
            setHour(0);
            return;
        }
        setHour(parseInt(hour || 0) + 1);
    };

    const downHour = () => {
        if(hour === 0 || hour === "" || hour === "00"){
            setHour(23);
            return;
        }

        setHour(parseInt(hour || 0) - 1);
    };

    const upMinute = () => {
        if(minute === 45){
            setMinute(0);
            return;
        }
        setMinute(parseInt(minute || 0) + 15);
    };

    const downMinute = () => {
        if(minute === 0 || minute === "" || minute === "00"){
            setMinute(45);
            return;
        }

        setMinute(parseInt(minute || 0) - 15);
    };

    const changeHour = (e) => {
        let str = e.target.value;
        if (typeof str != "string") return false; // we only process strings!  
        if(!isNaN(str) &&  !isNaN(parseFloat(str))){
            setHour(str.toString().length === 1 ? "0" + parseInt(str) : str.toString().length === 3 ? str.toString().substr(1,2) : str);
        }      
    };

    const changeMinute = (e) => {
        let str = e.target.value;
        if (typeof str != "string") return false; // we only process strings!  
        if(!isNaN(str) &&  !isNaN(parseFloat(str))){
            setMinute(str.toString().length === 1 ? "0" + parseInt(str) : str.toString().length === 3 ? str.toString().substr(1,2) : str);
        }      
    };

    const isSingle = (str, type) => {

        if(str && str.toString().length > 2){
            return str.toString().substring(1);
        }
        

        if(str === 0){
            return "00";
        }

        return str && str.toString().length === 1 ? "0" + parseInt(str) : str;
    };

    const getBackupDate = (str) => {
        let dateTimeArr = [];

        if(str && str.indexOf("_1.bak") > -1){
            dateTimeArr =  str.split("_1.bak");
        } else if(str.indexOf(".1.bak") > -1){
            dateTimeArr =  str.split(".1.bak");
        } else {
            dateTimeArr =  str.split(".bak");
        }

        let obj = dateTimeArr[0].lastIndexOf('_', dateTimeArr[0].lastIndexOf('_')-1);
        let dateTime = dateTimeArr[0].substring(obj + 1, 1000);
        let fromNow = moment(dateTime.replace("_",""), "YYYYMMDDHHmmss").fromNow();

        if(fromNow.indexOf("day ago") > -1 || fromNow.indexOf("days ago") > -1 ){
            setBackupIn24Hour(true);
        }
        setBackupDate(moment(dateTime.replace("_",""), "YYYYMMDDhhmmss").format('MM-DD-YYYY HH:mm:ss')  );
        return;
    };

    const addMeToNotification = async () => {        
        let accessToken = await auth.getToken();

        fetch(`/api/addToBackupNotification`, {
            method : "POST",
            headers: {
                'Content-Type' : 'application/json',
                'Authorization': "Bearer " + accessToken
            },
            body : JSON.stringify( { namespace : activeNamespace })
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => { 
            setNotificationMessage(data.Result);
        }).catch((error) => {
            window.apiError(error);
        });
        
    };

    const requestBackup = async (IsLatest, ) => {
        let accessToken = await auth.getToken();
        let realDate = moment(date).format("YYYY-MM-DD");
        let time = `${hour}:${minute}:00`;
        let requestedPITDate = `${realDate} ${time}`;
  
        let cerebro = sessionStorage.getItem("cerebroSession");
        if(cerebro){
            cerebro = JSON.parse(cerebro);
        }

        let requestData = {
            namespace : activeNamespace,
            IsFastLane: fastlaneEnabled,
            IsLatest: IsLatest,
            RequestedDateTime: requestedPITDate,
            CaseNumber: cerebro.cerebroCaseNumber,
            CaseValidationResult: 'NA',
        };


        fetch(`/api/requestBackup`, {
            method : "POST",
            headers: {
                'Content-Type' : 'application/json',
                'Authorization': "Bearer " + accessToken
            },
            body : JSON.stringify(requestData)
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => { 
            if(data.Result && data.Result.toLowerCase().indexOf("success") > -1){
                setBackupSubmitted(true);
                return;
            }

            setRequestError(data.Result);
        }).catch((error) => {
            window.apiError(error);
        });

    };

    const getMinDate = () => {
        let date = moment(dateNow.addDays(-2)).format('YYYY-MM-DD');
        let lastSat = moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD');

        if(date < lastSat){
            return new Date(lastSat).addDays(1);
        }

        return dateNow.addDays(-2);
    };

    const registerUserForAltocumulus = async () => {
        let teamId;

        setIsRegistering(true);

        switch(userTeam){
            case "Support - SMB Major | Global/Managed | PowerPay" : teamId = 3;
            break;

            case "Support - Enterprise" : teamId = 14;
            break; 

            case "Implementation" : teamId = 1;
            break; 

            case "Reporting | DF Link" : teamId = 15;
            break; 

            case "Technical Account Management" : teamId = 14;
            break; 

            case "Professional Services" : teamId = 4;
            break; 

            default : teamId = 1;
            break;
        }

        let accessToken = await auth.getToken();
        
        fetch(`/api/createNewDashboardUser`, {
            method : "POST",
            headers: {
                'Content-Type' : 'application/json',
                'Authorization': "Bearer " + accessToken
            },
            body : JSON.stringify({ TeamId: teamId })
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => { 
            setRequestSubmitted(true);
            setIsRegistering(false);
            if(teamId !== 1 || teamId !== 16 ){               
                
                fetch(`/api/checkuserregistered`, {
                    method : "GET",
                    headers: {
                        'Authorization': "Bearer " + accessToken
                    }
                })
                .then(response => {
                    if(response.status !== 200)
                    {   
                        let payload = [{
                            status : response.status,
                            rawmsg : response.statusText,
                            cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                            location: response.url,
                            timestamp : Date.now(),
                        }];
                        throw {
                            payload: payload,
                            error: new Error()
                        };
                    }
                    return  response.json();
                })
                .then(data => { 
                    if(data.LeaserID === 0){            
                        setUserAltocumulus(data);  
                        return;
                    }
                    props.userRegistered(true);
                    setUserAltocumulusAccess(true);
                    setUserAltocumulus(data);   
                    setRequestMsg("You have now been registered. You can close this popup")
                }).catch((error) => {
                    window.apiError(error);
                });
                return;
            }
            setRequestMsg(" Your registration has been submitted. Please note that Support apps are meant for use by Support and Professional Services Teams. - For non-Support/PS access, please log a case with Cloud Ops.");
        }).catch((error) => {
            window.apiError(error);
        });
    };

    if(isLoading){
        return (
            <div id="request-backup">
                <IsLoadingBar />
            </div>
        );
    }

    if(userNotRegistered){
        return (
            <div id="request-backup">
                {isRegistering ? 
                <> Registering </>
                :  
                <>
                    {!requestSubmitted ?
                    <div className="not-registered">
                        <h5>Hmm.. we cant find you! <img src={fetchConfused} /></h5>
                        <p>Please let us know what team you are on:</p>
                        <div className="register-options">
                            {teams.map((item,index) => 
                                <Form.Check
                                    type={'radio'}
                                    key={index}
                                    label={item}
                                    checked={userTeam === item}
                                    onClick={() => setUserTeam(item)}
                                    id={`default-${item}`}
                                />
                            )}
                        </div>  
                        <Button onClick={() => registerUserForAltocumulus()}>Register</Button>
                    </div>     
                    :
                    <div className="text-center">
                        <img src={fetchShock} />       
                        <h5 className="w-75 mx-auto mt-3">{requestMsg}</h5>
                    </div>  
                    }  
                </>
                }       
            </div>
       );
    }

    if(backupInQueue){
        return (
            <div id="request-backup">
                <div className="backup-in-queue">
                    <h5>Backup in Queue</h5>
                    <h6>Ooh Snap! it looks like there is already a backup in the queue for <b>{activeNamespace}</b>. </h6>
                    <div className="img-container" style={{height: "220px"}}>
                        <img src={fetchShock} />
                    </div>                    
                    <p>Would you like to be added to the notification list?</p>
                    {notificationMessage && (
                        <p className="notification mb-3">{notificationMessage}</p>
                    )}
                    <Button onClick={() => addMeToNotification()}>Notify Me</Button>
                    <Button variant="link" className="color-muted" onClick={() => props.close()}><small>Cancel</small></Button>
                </div>                
            </div>
        );    
    }

    if(backupAvailable){
        return (
            <div id="request-backup">
                <div className="backup-in-queue">
                    <h5>Backup Available</h5>
                    <h6>Hmmm... there seems to be a recent backup for <b>{activeNamespace}</b>.</h6>
                    <p className="mb-2"><b>{backupFileName}</b></p>
                    <p>Backup Date/Time: <b>{backupDate}</b></p>
                    <img src={fetchShock} />
                    <p>How would like to proceed?</p>
                    <Button onClick={() => { props.useExistingBackup(); }}>Use this backup</Button>
                    <Button variant="link" onClick={() => setBackupAvailable(false)}><small>Request Backup</small></Button>
                </div>                
            </div>
        );
    }

    if(backupSubmitted){
        return (
            <div id="request-backup">
                <div className="backup-in-queue">
                    <h5>Backup Requested</h5>
                    <h6>Your back request has been submitted.</h6>
                    
                    <img src={check} />
                    <p>You will receive a notification once the backup is complete.</p>
                    <Button variant="link" className="color-muted" onClick={() => props.close()}><small>Close</small></Button>
                </div>                
            </div>
        );
    }

    return (
        <div id="request-backup">
            {!backupType && (
                <>
                    <h5>Backup Request</h5>
                    <p>You now have two options:</p>
                    {userHasFastLaneAccess && (
                         <Form.Check 
                         custom
                         className="mx-3 mt-2"
                         type={"checkbox"}
                         onChange={() => setFastlaneEnabled(true)}
                         id={`custom-fast-lane`}
                         label={`Fast Lane`}
                       />
                    )}
                    <div className="backup-options">
                        <div className="d-inline-block w-50 p-3" onClick={() => { backupIn24Hour ? requestBackup(1,null) : requestBackup(1,null)} } >
                            <div className="option">
                                <img src={backupNew} />
                                <h6>Latest backup</h6>
                                {backupIn24Hour ?
                                <p>(backup already exists)<br /><br /></p>                                
                                :
                                <p>(most recent transactions included)</p>
                                }
                            </div>
                        
                        </div>
                        <div className="d-inline-block w-50 p-3" onClick={() => { setRequestError(false); setBackupType("point-in-time") } }>
                            <div className="option">
                                <img src={backupPointInTime} />
                                <h6>Point-in-time backup</h6>
                                <p>For backups that are slightly older (max: 2 business days prior)</p>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {backupType && (
                <>
                    <h5>Point in Time Request</h5>
                    <p>Please choose date and time for backup.</p>
                    <div className="point-in-time">                  
                        <div>
                            <Calendar onChange={item => setDate(item)} minDate={getMinDate()} maxDate={dateNow.addDays(0)}
                            date={date} />
                            <div className="time">
                                {date && (
                                    <>
                                        <div className="time-container">
                                            <Button onClick={() => upHour()}><i className="fas fa-chevron-up"></i></Button>
                                            <input value={isSingle(hour,"hour")} onFocus={() => setHour("")} onChange={(e) => changeHour(e)} className="hour" placeholder="00" />
                                            <Button onClick={() => downHour()}><i className="fas fa-chevron-down"></i></Button>
                                        </div>
                                        <div className="time-container">
                                            <Button onClick={() => upMinute()}><i className="fas fa-chevron-up"></i></Button>
                                            <input id="minute-input" value={isSingle(minute,"minute")} onChange={(e) => changeMinute(e)} onFocus={() => setMinute("")} placeholder="00" />
                                            <Button onClick={() => downMinute()}><i className="fas fa-chevron-down"></i></Button>
                                        </div> 
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="text-right">
                            <Button disabled={!date} onClick={() => requestBackup(0,moment(date + hour  + minute + "00").format("YYYY-MM-DD hh:mm:ss"))  }>Proceed</Button>
                            <Button variant="link" className="color-muted" onClick={() => props.close()}><small>Cancel</small></Button>
                        </div>                        
                    </div>
                </>
            )}
            {requestError && (
                <p className="text-danger pl-3">{requestError}</p>
            )}

        </div>
   );

}

export default RequestBackup;
